import Vue from 'vue'
import Header from './Header.vue'
import store from '@/store'
import config from '@/mixins/componentConfiguration'
import commonConfig from '@/mixins/commonMixin'

window.vm1 = new Vue({
  store,
  mixins: [commonConfig(Vue), config(Vue)],
  render: h => h(Header)
}).$mount('#header')
